/**
 * 品牌主题（hpsfir-managebase-ui 1.0.0 主题体系）。
 *
 * 1.0.0 起框架不再通过插件选项注入布局/登录页（adminLayoutCnt / loginCnt 已移除），
 * 改为「主题」机制：
 *   - `theme` 可传内置主题名（'default' / 'ultra'），也可传自定义主题对象；
 *   - 自定义主题用 `extend` 声明继承，框架会**先注册父主题、再注册本主题**，后者覆盖前者；
 *   - `registerThemeComponents(app)` 中注册的同名组件会覆盖父主题的组件。
 *
 * 这里继承 ultra（官方后台布局 + 新组件体系），只覆写 LoginView；
 * 品牌主色不通过主题配置传递（包只发布单文件 bundle，未导出 applyUltraThemeConfig），
 * 而是在 main.ts 里以 CSS 变量注入，见 applyBrandColor()。
 */
import type { App } from 'vue';
import BrandLogin from './BrandLogin.vue';

/** 品牌主色（与小程序端、原管理后台保持一致的蓝） */
export const BRAND_PRIMARY = '#5B9BD5';

export const brandTheme = {
  name: 'search-track-brand',
  extend: 'ultra',
  registerThemeComponents(app: App) {
    // 覆写父主题的登录页；后台布局沿用 ultra 主题的官方实现
    app.component('LoginView', BrandLogin);
  },
};

/**
 * 注入品牌色。
 *
 * ultra 主题注册时会往 <head> 追加一段 `:root { --primary: ... }` 的运行时样式，
 * 它在 DOM 里晚于打包进产物的样式表，因此用样式表覆盖无效；
 * 这里直接写在 <html> 的行内样式上——行内声明优先级高于任何同重要性的样式表规则。
 */
export const applyBrandColor = () => {
  const root = document.documentElement;
  root.style.setProperty('--primary', BRAND_PRIMARY);
  root.style.setProperty('--hpsfir-primary-color', BRAND_PRIMARY);
  root.style.setProperty('--ring', BRAND_PRIMARY);
  root.style.setProperty('--sidebar-primary', BRAND_PRIMARY);
  root.style.setProperty(
    '--primary-gradient',
    `linear-gradient(135deg, ${BRAND_PRIMARY} 0%, #7ab4e0 100%)`,
  );
};
